import axios from "services/axios";
import {useMutation} from "react-query";

export function useResetPassword({token}) {
	return useMutation(values =>
		axios.post(`/auth/set_new_password?change_token=${token}`, values).then(res => res.data),
	);
}
